export const INPUT_CONTAINER = "text-sm w-full";
export const INPUT_FIELD_WITH_BUTTON_CLASS =
    "bg-transparent focus:outline-none rounded-l w-[100%] px-4 opacity-50 sm:border sm:border-New_Primary_Default ";
export const INPUT_FIELD_WITH_BUTTON_CONTAINER =
    "flex flex-row border border-New_Primary_Default sm:border-transparent	 ";
export const INPUT_FIELD_ERROR =
    "bg-transparent border border-Error_Default focus:outline-none rounded-l w-[100%] px-4 ";
